import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import illustration from '@svg/illustrations/success_card_activation.svg';
import { useTranslation } from 'react-i18next';

const SuccessActivateCardModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'activate_card'
    });
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="illustration" />
            <Typography className={styles.title} variant="h4">
                Your card has been activated
            </Typography>
            <Typography className={styles.description} variant="body2">
                Now, load your XEPPT card balance to start using it right away.
            </Typography>
        </div>
    );
};

export default SuccessActivateCardModal;
